export default __webpack_public_path__ + "static/media/in-progress-not-selected.9e8d03d6.svg";